<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="3" lg="3" class="mx-0 px-0">
						<!-- <v-text-field v-model="tableProps.search" label="Buscar un banco" clearable prepend-inner-icon="mdi-magnify" hide-details></v-text-field> -->
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}"
                            @onClear="(v) => {trySearch(v);}"
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            :clearable="true"
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3"
                        ></alternativeTextField2>
					</v-col>
					<v-spacer></v-spacer>
					<v-col   md="5" class="mx-0">
                        <v-row justify="end">
                            <iconButton :props="createBtnData" v-permission="'credit_notes.create'"></iconButton>
                        </v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<datatablePagination :options="options" :total="total"  :props="tableProps" @methodHandler="method_handler" @handleOptions="handleOptions">
                           
                        </datatablePagination>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

        <modal :props="modalProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" sm="4">
						<secondaryButton
						:props="cancelModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" sm="4">
						<primaryButton
						:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>
		
	</div>
</template>
<script>
import PageStateManager from '../../helpers/PageStateManager';
import Utils from '../../helpers/Utils';
export default {
    data(){
		return {
            options: JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable'))??{},
            total: 10,
			search: '',
            selectedID: '',
			actions: [
                {
					name: 'Adjunto',
					icon: {
						color: 'secondary',
						icon: 'mdi-file-document-outline'
					},
					disabled: true,
					type: 'external',   //  method, external, redirect
					action: '',
                    permissions: 'credit_notes.show'
				},
				{
					name: 'Detalle',
					icon: {
						color: 'secondary',
						icon: 'mdi-information-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'credit_notes.show'
				},
				{
					name: 'Editar',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/obras/1/edicion',
                    permissions: 'credit_notes.update'
				},
				{
					name: 'Borrar',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItemModal',
                    permissions: 'credit_notes.delete'
				},
			],
			tableProps: {
				headers: [
					{
						text: 'Folio',
						align: 'left',
						value: 'folio',
						width: '9%',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cuenta',
						align: 'left',
						value: 'account_name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Sub Cuenta',
						align: 'left',
						value: 'concept_name',
                        width: '5%',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Proveedor',
						align: 'left',
                        
						value: 'provider_name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Monto',
						align: 'left',
						value: 'total',
                        
						class: 'table-b-border black--text'
					},
                    
                    {
						text: 'Estatus',
						align: 'left',
						value: 'status',
                        width: '5%',
						class: 'table-b-border black--text'
					},
					{
						text: 'ACCIONES',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '10%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: (JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable')))?.search??"",
				loading: false,
                sortBy: 'created_at',
                sortDesc: true,
			},
			
			
            createBtnData: {
                hasTooltip:true,
                tooltip: 'Nueva Nota de crédito',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-plus",
				to: "CreditNotesCreate",
				block: false,
                click: ()=>{}
            },
           
			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                click: ()=>{this.delete()}
            },
		}
	},

	mounted(){
		//this.index()
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
	},

    methods: {
        onResize () {
            
            if(window.innerWidth < 960){
                this.createBtnData.block = true;
            }
            else{
                this.createBtnData.block = false;
            }
        },
        method_handler(object){
            console.log(object);
			this[object.methodName](object.parameters)
		},
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			//console.log(object.options);
			this.options = object.options;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options))
			this.index();
		},
        trySearch(val){
            this.tableProps.search = val;
            this.options.search = val;
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options))
            this.index();
        },
		index() {
			this.tableProps.loading = true;
            this.options['search'] = this.tableProps.search;
			let filter = Utils.createFilter(this.options, this.tableProps.headers);
			//call api
			this.$api.creditNote.list(this.$store.state.business, filter)
				.then((resp) =>{
					//console.log(resp);
					this.tableProps.items = resp.data.data.map((x) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions));
                        if(x.invoice_file_url != null && x.invoice_file_url != ''){
                            x.actions[0].action = x.invoice_file_url;
                            x.actions[0].disabled = false;
                        }
                        

						//x.actions[0].action = { name: '', params: { slug: x.slug } }
						x.actions[1].action = { name: 'CreditNotesDetails', params: { slug: x.slug } }
                        x.actions[2].action = { name: 'CreditNotesEdit', params: { slug: x.slug } }
						

						x['parameters'] = { 
                            id: x.slug, 
                            name: x.folio,
                            
                        };
                        
                        x.status = x.status == "ejecutada" ? "Aplicada" : x.status;
                        x.total = Utils.currencyFormat((x.total), x.currency);
						return x;
					});
                    this.total = resp.data.total
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},

      

		deleteItemModal(parameters)
		{
			//console.log(parameters);
			this.acceptModal.text = "SI, ELIMINAR";
            this.cancelModal.text = "No, cancelar";
            this.acceptModal.click = this.delete;
            this.acceptModal.color = 'error';
			this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás a punto de eliminar ¿deseas continuar?`,
				title: 'Eliminar',
                bottomLineColor: 'error',
			}
            //console.log(this.selectedID)
			this.modalProps.visible = true;
			
		},


		delete()
		{
			//console.log(this.selectedID);
			this.acceptModal.loading = true;
			this.$api.creditNote.delete(this.$store.state.business,this.selectedID)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', `Se ha eliminado`);
				this.index()
				// eslint-disable-next-line
			}).catch(error => {
				if(error.response.status === 422){
                    this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al eliminar'}`);
                }else{
                    this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
                }

				
			})
			.finally(() => {
				this.modalProps.visible = false;
				this.acceptModal.loading = false;
			})
		},


    }
}
</script>